import iconOto from './assets/iconotoo.png';
import iconXeMay from './assets/iconxemay.png';
import iconSucKhoe from './assets/iconsuckhoe.png';
import iconDuLich from './assets/icondulich.png';
import iconHangHoa from './assets/hanghoa.png';
import iconNha from './assets/nha.png';
import why1 from './assets/1.png';
import why2 from './assets/2.png';
import why3 from './assets/3.png';
import why4 from './assets/4.png';
import why5 from './assets/5.png';
import stat6 from './assets/6.png';
import stat7 from './assets/7.png';
import stat8 from './assets/8.png';
import stat9 from './assets/9.png';
import benefit10 from './assets/10.png';
import benefit11 from './assets/11.png';
import benefit12 from './assets/12.png';
import benefit13 from './assets/13.png';
import benefit14 from './assets/14.png';
import toyota from './assets/toyota.png';
import honda from './assets/honda.png';
import ford from './assets/ford.png';
import vin from './assets/vin.png';
import thaco from './assets/thaco.png';
import mitsubishi from './assets/mitsubishi.png';
import mg from './assets/mg.png';
import omoda from './assets/omoda.png';
import byd from './assets/byd.png';
import mec from './assets/mec.png';
import lexus from './assets/lexus.png';
import avt1 from './assets/avt1.png';
import avt2 from './assets/avt2.png';

export const productIcons = {
  oto: iconOto,
  xemay: iconXeMay,
  suckhoe: iconSucKhoe,
  dulich: iconDuLich,
  hanghoa: iconHangHoa,
  nha: iconNha,
};

export const whyChooseIcons = {
  'why-1': why1,
  'why-2': why2,
  'why-3': why3,
  'why-4': why4,
  'why-5': why5,
};

export const statsIcons = {
  'stat-6': stat6,
  'stat-7': stat7,
  'stat-8': stat8,
  'stat-9': stat9,
};

export const benefitIcons = {
  'benefit-10': benefit10,
  'benefit-11': benefit11,
  'benefit-12': benefit12,
  'benefit-13': benefit13,
  'benefit-14': benefit14,
};

export const partnerLogos = {
  toyota,
  honda,
  ford,
  vin,
  thaco,
  mitsubishi,
  mg,
  omoda,
  byd,
  mec,
  lexus,
};

export const testimonialAvatars = {
  avt1,
  avt2,
};
